import axios from 'axios'
import { config, url } from '../../index'

// TODO: шпаргалка по типам (department.type):
// 0 - основатель (компания),
// 1 - исполнительный директор,
// 2 - директоры (подчиняются исполнительному)
// 3 - отделения
// 4 - отделы
// 5 - секции в составе отделов
// 6 - сектора в составе секции

const state = () => ({
  mainDepartment: {},
  departments: {},
  modals: {
    structure: {
      active: false,
      department: {}
    },
    update: {
      active: false,
      department: {}
    },
    detail: {
      active: false,
      department: {}
    },
    settings: {
      active: false,
      department: { id: null, name: '' },
      parentDepartment: { id: null, name: 'Не установлен' },
      type: { id: 4, name: 'Отдел' },
      typeList: [
        { id: 1, name: 'Исполнительный директор' },
        { id: 2, name: 'Директор' },
        { id: 3, name: 'Отделение' },
        { id: 4, name: 'Отдел' },
        { id: 5, name: 'Секция' },
        { id: 6, name: 'Сектор' }
      ]
    }
  },
  pageScale: {
    currentScale: '.6',
    options: [{ id: 1, active: false, value: '.8', text: '100%' }, { id: 2, active: true, value: '.6', text: '50%' }, { id: 3, active: false, value: '.3', text: '25%' }]
  },
  isLoading: true
})

// функции многоразового использования
// рекурсия обхода дерева отделов
const parseDepartments = (department, filter) => {
  const result = filter(department)
  const children = department.children !== undefined ? department.children.slice() : []
  const directChildren = department.direct_children !== undefined ? department.direct_children.slice() : []
  if (children.length !== 0) {
    result.children = result.children.map(e => parseDepartments(e, filter))
  }
  if (directChildren.length !== 0) {
    result.direct_children = result.direct_children.map(e => parseDepartments(e, filter))
  }
  return result
}

const getters = {
  getDepartments: state => state.departments,
  getMainDepartment: state => state.mainDepartment,
  departmentsTreeModals: state => state.modals,
  departmentForUpdate: state => state.modals.update.department,
  departmentForDetail: state => state.modals.detail.department,
  departmentsTreePageScale: state => state.pageScale,
  departmentsTreeSettings: state => state.modals.settings,
  departmentsTreeIsLoading: state => state.isLoading
}

const mutations = {
  // запись в стейт всех отделов и главного отдела
  GET_DEPARTMENTS: (state, departments) => {
    const appendFlagsAndColors = object => {
      // если тип "Отделение" то всем дочерним ("Отделам") устанавливаем цвет отделения
      if (object.type === 3 || object.type === 4) {
        object.children.map(child => {
          child.color = object.color
        })
      }
      return {
        ...object,
        isControlsActive: false,
        isStaffListActive: false
      }
    }

    // обновления отдела, который является родителем в модалке
    const updateModalParent = object => {
      const modalParentId = state.modals.structure.department.id
      const result = { ...object }

      if (result.id === modalParentId) {
        state.modals.structure.department = {
          ...result,
          modal_parent: true
        }
      }
      return result
    }

    /* структура формируется на основе первого отдела из GET /departments, выгруженные из 1С в дерево не попадут */
    const departmentsState = {
      ...departments['0'],
      /* основное дерево дочерних формируем из отделов с типом 1 (Директор) */
      children: departments['0'].children.filter(department => {
        return department.type === 1
      }),
      /* могут быть отделы подчинающиеся непосредственно владельцу, их фильтруем в соседнее дерево (непосредственного подчинения) */
      direct_children: departments['0'].children.filter(department => {
        return department.type !== 1
      })
    }

    state.mainDepartment = parseDepartments(departmentsState, appendFlagsAndColors)
    // переустанавливаем родительский отдел в модалке
    if (state.modals.structure.active) {
      state.mainDepartment = parseDepartments(state.mainDepartment, updateModalParent)
    }

    state.isLoading = false
  },
  SET_DEPARTMENTS_TREE_PAGE_SCALE: (state, optionId) => {
    const options = state.pageScale.options
    const selected = options.filter(option => {
      return option.id === optionId
    }).shift()
    options.forEach(option => {
      option.active = false
    })
    selected.active = true
    state.pageScale.currentScale = selected.value
  },
  // показ модалки структуры, записываем в стейт текущий отдел и помечаем его свойством (для условной отрисовки кнопки "еще отделов")
  DEPARTMENTS_TREE_MODAL_SHOW: (state, department) => {
    state.modals.structure.active = true
    state.modals.structure.department = {
      ...department,
      modal_parent: true
    }
  },
  // закрытие модалки с продолжением структуры отделов
  DEPARTMENTS_TREE_MODAL_CLOSE: (state) => {
    state.modals.structure.active = false
    state.modals.structure.department = {}
  },
  DEPARTMENTS_TREE_DETAIL_MODAL_SHOW: (state, department) => {
    state.modals.detail.active = true
    state.modals.detail.department = { ...department }
  },
  DEPARTMENTS_TREE_DETAIL_MODAL_CLOSE: (state) => {
    state.modals.detail.active = false
    state.modals.detail.department = {}
  },
  // показ модалки для редактирования отдела, копируем до профиля
  // иначе измененные данные отразятся в текущих карточках отделов
  DEPARTMENTS_TREE_UPDATE_MODAL_SHOW: (state, department) => {
    state.modals.update.active = true
    state.modals.update.department = {
      ...department,
      head_id: department.head_id,
      head: department.head ? {
        ...department.head,
        profile: { ...department.head.profile }
      } : { profile: {} },
      users: department.users.map(user => {
        return {
          id: user.id,
          name: user.profile.full_name
        }
      })
    }
  },
  // закрытие модалки для редактирования отдела
  DEPARTMENTS_TREE_UPDATE_MODAL_CLOSE: (state) => {
    state.modals.update.active = false
    state.modals.update.department = {}
  },
  SET_DEPARTMENT_NAME: (state, name) => {
    state.modals.update.department.name = name
  },
  SET_DEPARTMENT_HEAD: (state, head) => {
    state.modals.update.department.head_id = head.id
    state.modals.update.department.head.profile.full_name = head.name
  },
  SET_DEPARTMENT_CKP: (state, text) => {
    state.modals.update.department.ckp = text
  },
  SET_DEPARTMENT_DUTIES: (state, text) => {
    state.modals.update.department.duties = text
  },
  SET_DEPARTMENT_INSTRUCTION: (state, text) => {
    state.modals.update.department.instruction = text
  },
  SET_DEPARTMENT_FOLDER: (state, text) => {
    state.modals.update.department.folder = text
  },
  ADD_DEPARTMENT_STAFF_USER: (state, staffUser) => {
    state.modals.update.department.users.push(staffUser)
  },
  REMOVE_DEPARTMENT_STAFF_USER: (state, staffUser) => {
    state.modals.update.department.users = state.modals.update.department.users.filter(user => {
      return user.id !== staffUser.id
    })
  },
  SET_DEPARTMENT_COLOR: (state, color) => {
    state.modals.update.department.color = color
  },
  TOGGLE_DEPARTMENTS_TREE_ITEM_CONTROLS: (state, departmentId) => {
    const pageToggleControls = object => {
      const result = {
        ...object
      }
      const modalDepartmentId = state.modals.structure.department.id
      if (result.id === departmentId && result.id !== modalDepartmentId) {
        result.isControlsActive = !result.isControlsActive
        result.isStaffListActive = false
      } else {
        result.isControlsActive = false
        result.isStaffListActive = false
      }
      return result
    }

    const modalToggleControls = object => {
      const result = {
        ...object
      }
      if (result.id === departmentId) {
        result.isControlsActive = !result.isControlsActive
        result.isStaffListActive = false
      } else {
        result.isControlsActive = false
        result.isStaffListActive = false
      }
      return result
    }

    // переключение меню карточек отделов на основной странице
    state.mainDepartment = parseDepartments(state.mainDepartment, pageToggleControls)
    // переключение меню карточек отделов в модалке
    if (state.modals.structure.active) {
      state.modals.structure.department = parseDepartments(state.modals.structure.department, modalToggleControls)
    }
  },
  TOGGLE_DEPARTMENTS_TREE_ITEM_STAFF_LIST: (state, departmentId) => {
    const pageToggleStaffList = object => {
      const result = {
        ...object
      }
      const modalDepartmentId = state.modals.structure.department.id
      if (result.id === departmentId && result.id !== modalDepartmentId) {
        result.isStaffListActive = !result.isStaffListActive
        result.isControlsActive = false
      } else {
        result.isControlsActive = false
        result.isStaffListActive = false
      }
      return result
    }

    const modalToggleStaffList = object => {
      const result = {
        ...object
      }
      if (result.id === departmentId) {
        result.isStaffListActive = !result.isStaffListActive
        result.isControlsActive = false
      } else {
        result.isControlsActive = false
        result.isStaffListActive = false
      }
      return result
    }

    // переключение меню карточек отделов на основной странице
    state.mainDepartment = parseDepartments(state.mainDepartment, pageToggleStaffList)
    // переключение меню карточек отделов в модалке
    if (state.modals.structure.active) {
      state.modals.structure.department = parseDepartments(state.modals.structure.department, modalToggleStaffList)
    }
  },
  CLOSE_DEPARTMENTS_TREE_ITEM_POPUPS: (state) => {
    const closePopups = object => {
      return {
        ...object,
        isControlsActive: false,
        isStaffListActive: false
      }
    }

    // закрытие меню и списка сотрудников в карточках отделов на странице и в модалке
    state.mainDepartment = parseDepartments(state.mainDepartment, closePopups)

    if (state.modals.structure.active) {
      state.modals.structure.department = parseDepartments(state.modals.structure.department, closePopups)
    }
  },
  '[department-tree] OPEN_SETTINGS_MODAL': state => {
    state.modals.settings.active = true
  },
  '[department-tree] SET_SETTINGS_DEPARTMENT': (state, department) => {
    state.modals.settings.department = department
  },
  '[department-tree] SET_SETTINGS_PARENT': (state, department) => {
    state.modals.settings.parentDepartment = department
  },
  '[department-tree] SET_SETTINGS_TYPE': (state, type) => {
    state.modals.settings.type = type
  },
  '[department-tree] CLOSE_SETTINGS_MODAL': state => {
    const modal = state.modals.settings

    modal.active = false
    modal.department = { id: null, name: '' }
    modal.parentDepartment = { id: null, name: 'Не установлен' }
    modal.type = { id: 4, name: 'Отдел' }
  }
}

const actions = {
  getDepartments ({ commit }) {
    axios.get(`${url}/departments/tree`, config).then(response => {
      commit('GET_DEPARTMENTS', response.data)
    })
  },
  setDepartmentTreePageScale ({ commit }, optionId) {
    commit('SET_DEPARTMENTS_TREE_PAGE_SCALE', optionId)
  },
  showDepartmentTreeModal ({ commit }, department) {
    commit('DEPARTMENTS_TREE_MODAL_SHOW', department)
  },
  closeDepartmentTreeModal ({ commit }) {
    commit('DEPARTMENTS_TREE_MODAL_CLOSE')
  },
  toggleDepartmentsTreeItemControls ({ commit }, departmentId) {
    commit('TOGGLE_DEPARTMENTS_TREE_ITEM_CONTROLS', departmentId)
  },
  toggleDepartmentsTreeItemStaffList ({ commit }, departmentId) {
    commit('TOGGLE_DEPARTMENTS_TREE_ITEM_STAFF_LIST', departmentId)
  },
  closeDepartmentsTreeItemPopups ({ commit }) {
    commit('CLOSE_DEPARTMENTS_TREE_ITEM_POPUPS')
  },
  showUpdateDepartmentModal ({ commit }, department) {
    commit('DEPARTMENTS_TREE_UPDATE_MODAL_SHOW', department)
  },
  closeUpdateDepartmentModal ({ commit }) {
    commit('DEPARTMENTS_TREE_UPDATE_MODAL_CLOSE')
  },
  updateDepartmentName ({ commit }, name) {
    commit('SET_DEPARTMENT_NAME', name)
  },
  updateDepartmentHead ({ commit }, head) {
    commit('SET_DEPARTMENT_HEAD', head) // на входе объект нового руководителя (id и name)
  },
  updateDepartmentCkp ({ commit }, text) {
    commit('SET_DEPARTMENT_CKP', text)
  },
  updateDepartmentDuties ({ commit }, text) {
    commit('SET_DEPARTMENT_DUTIES', text)
  },
  updateDepartmentInstruction ({ commit }, text) {
    commit('SET_DEPARTMENT_INSTRUCTION', text)
  },
  updateDepartmentFolder ({ commit }, text) {
    commit('SET_DEPARTMENT_FOLDER', text)
  },
  addDepartmentStaffUser ({ commit }, user) {
    commit('ADD_DEPARTMENT_STAFF_USER', user)
  },
  removeDepartmentStaffUser ({ commit }, user) {
    commit('REMOVE_DEPARTMENT_STAFF_USER', user)
  },
  updateDepartmentColor ({ commit }, color) {
    commit('SET_DEPARTMENT_COLOR', color)
  },
  updateDepartment ({ state, commit, dispatch }) {
    const staffIds = state.modals.update.department.users.map(user => {
      return user.id
    })

    const departmentData = {
      id: state.modals.update.department.id,
      name: state.modals.update.department.name,
      head_id: state.modals.update.department.head_id,
      ckp: state.modals.update.department.ckp,
      duties: state.modals.update.department.duties,
      instruction: state.modals.update.department.instruction,
      folder: state.modals.update.department.folder,
      color: state.modals.update.department.color,
      user_ids: staffIds
    }

    const updateData = axios.put(`${url}/departments/${departmentData.id}`, departmentData, config)
    /* const updateStaff = axios.post(`${url}/departments/${state.modals.update.department.id}`, `user_ids=${staffIds}`, config) */

    axios.all([updateData]).then((response) => {
      this.dispatch('closeUpdateDepartmentModal')
      // получаем обновленные данные отделов
      this.dispatch('getDepartments')
    }).then(() => {
      // после изменений в структуре отделов, заного получаем список отделов для селектов
      dispatch('[dictionaries] getDepartmentList')
    }).catch(error => {
      this.dispatch('closeUpdateDepartmentModal')
      console.log('update department error', error)
    })
  },
  removeDepartment ({ commit }, departmentId) {
    axios.delete(`${url}/departments/${departmentId}`, config).then(() => {
      this.dispatch('getDepartments')
    }).catch(error => {
      console.log(error.response)
    })
  },
  showDetailDepartmentModal ({ commit }, department) {
    commit('DEPARTMENTS_TREE_DETAIL_MODAL_SHOW', department)
  },
  closeDetailDepartmentModal ({ commit }) {
    commit('DEPARTMENTS_TREE_DETAIL_MODAL_CLOSE')
  },
  '[department-tree] closeSettingsModal' ({ commit }) {
    commit('[department-tree] CLOSE_SETTINGS_MODAL')
  },
  '[department-tree] updateDepartmentStructurePlace' ({ dispatch, commit, state }) {
    const modal = state.modals.settings
    const params = {
      id: modal.department.id,
      updateData: {
        parent_id: modal.parentDepartment.id,
        type: modal.type.id
      }
    }

    axios.put(`${url}/departments/${params.id}`, params.updateData, config).then(() => {
      commit('[department-tree] CLOSE_SETTINGS_MODAL')
      dispatch('getDepartments')
    }).catch(error => {
      console.log('ошибка настройки отдела в структуре', error.response ? error.response : error)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
